module.exports = __webpack_public_path__ + "static/media/akshay-hangloor.0698573a.jpeg";